<ngx-loading-bar></ngx-loading-bar>
<a href="https://api.whatsapp.com/send?phone=628119108685&text=Halo%21%20Klink Hewan Rajanti."
    class="float" target="_blank">
    <i class="fa fa-whatsapp my-float"></i>
</a>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
